"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ArrowUp = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/ArrowUp"));

// Generated by script, don't edit it please.
var ArrowUp = (0, _createSvgIcon["default"])({
  as: _ArrowUp["default"],
  ariaLabel: 'arrow up',
  category: 'direction',
  displayName: 'ArrowUp'
});
var _default = ArrowUp;
exports["default"] = _default;
module.exports = exports.default;